<div class="innerBanner" style="background-image: url('../../../assets/images/banner-accommodation.avif')">
  <div class="bannerText">
    <h1>{{ 'Cookie Policy' | translate }}</h1>
  </div>
</div>
<div class="container mt-2">
  <p>
    We may automatically collect Information using "cookies," which are small files placed on your hard drive that may
    uniquely identify your browser and collect certain Information about you. Among other things, cookies help us
    analyze our web page flow, customize our service, measure promotional effectiveness, and promote trust and safety.
    Certain features are only available through the use of cookies, and generally we need to use cookies to help
    identify you and maintain your signed-in status. You are always free to decline cookies via your browser settings,
    although doing so may interfere with your use of the Offerings. You may encounter cookies from third parties that we
    do not control.
  </p>
  <p>
    We may additionally collect Information using pixel tags, web beacons or other web site usage tracking technologies.
    Web beacons (also known as "tracking pixels") are electronic images that may be used in the service or in emails
    that we send to you. We may use web beacons to deliver cookies, count visits, understand usage and campaign
    effectiveness and to tell if an email has been opened and acted upon. Such devices are used to collect non-personal
    data, such as the identity of the applicable internet service provider, the type of browser software and operating
    system in use, the date and time of site access, and other similar traffic-related information. We also may
    aggregate such information with similar data collected from other users. However, we do not use such data in any way
    to create or maintain personal data about you.
  </p>
</div>
